import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../../../utils/queries';

//dropdown EMPRESAS
const DetalleEmpNivel1 = props => {
  return (
    <option>{props.elemento.descrEmpresa}</option>
  )
};

const ListaEmp = ({list, handleLista}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" onChange={handleLista}>
        {/* <option value="">Seleccionar Empresa...</option> */}
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown EMPRESAS

const DetalleOpeNivel1 = props => {
  return (
    <option dato1={props.elemento.cedula} value={props.elemento.nombreUsuario}>{props.elemento.nombreUsuario}</option>
  )
};

const ListaOpe = ({list, handleLista}) => {
  const Nivel4Detalle = list.map((elemento, _id) => <DetalleOpeNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="nombreUsuario" id="miLista2" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel4Detalle}
      </select>
    </div>
  )
};

class AddOrdenCompra2 extends React.Component{
  state={argsAdd: {}}

  handleChange = async (ev) => {
    const argsAdd = this.state.argsAdd
    this.setState({argsAdd})
  }

render(){
  const {argsAdd} = this.state;
  let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
  let args = Object.assign({}, this.props.args, argsAdd)

  return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
      <i className="large plus yellow icon"></i>
      Orden de compra nueva
      </button>
      <div style={this.props.styles.box}>
        <Form onSubmit={(ev)=>this.props.handleSubmit(ev, args)}> 
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" width="50%">                
                <Form.Field>
                  <label style={this.props.styles.label}>Responsable</label>
                  <ListaOpe list={this.props.list1} handleLista={this.props.handleLista3} />
                </Form.Field>    
              </div>
              <div className="column" width="50%">
                <Form.Field>
                  <label style={this.props.styles.label}>Empresa</label>
                  <ListaEmp list={this.props.list} handleLista={this.props.handleLista} />
                </Form.Field>
              </div>
            </div>
          </div>
          {/* <div className="row container">              
            <div className="column" width="100%">  
              <Form.Field>
                  <label style={this.props.styles.label}>Observaciones</label>
                  <Form.Input autoComplete="off" name="observaciones" id="observaciones" onChange={this.props.handleChange} placeholder='Observaciones' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'observaciones'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
              </Form.Field> 
            </div>
          </div> */}
          <div className="row container">
            <div className="column" width="100%">                
              <Button style={this.props.styles.confirmar} type='submit' fluid>
                AGREGAR
              </Button>
            </div>
            {
              this.props.errors.length?<Message negative header="Los siguientes errores:"
              list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }
          </div>
        </Form>
      </div>
    </div>
  )
  }
}

export default compose(

  )(AddOrdenCompra2)